// Données de la maquette utilisées par le cadre (menu, barre du haut). Extraites du HTML de référence : rien n'est retapé à la main.
// Les descriptions et les champs des entités seront ajoutés avec les écrans qui en ont besoin.

export interface MaquetteGroup {
  key: string
  label: string
  icon: string
  description: string
  entities: string[]
}

export interface MaquetteModule {
  label: string
  icon: string
  description: string
  entities: string[]
  reports: string[]
  groups: MaquetteGroup[]
}

export interface MaquetteEntity {
  label: string
  labelPlural: string
  icon: string
  module: string
  storageKey: string | null
}

export interface MaquetteReport {
  label: string
  icon: string
  module: string
}

/** Contenu SVG des icônes (ICON_DEFS de la maquette). */
export const ICON_DEFS: Record<string, string> = {
  "alert-triangle": "<path d=\"M12 3 22 20 2 20Z\"/><line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"14\"/><circle cx=\"12\" cy=\"17.3\" r=\"0.6\" fill=\"currentColor\" stroke=\"none\"/>",
  "archive": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"4\" rx=\"1\"/><path d=\"M4 8v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8\"/><line x1=\"10\" y1=\"13\" x2=\"14\" y2=\"13\"/>",
  "arrow-right": "<line x1=\"4\" y1=\"12\" x2=\"20\" y2=\"12\"/><polyline points=\"14 6 20 12 14 18\"/>",
  "backpack": "<path d=\"M6 8a6 6 0 0 1 12 0v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1Z\"/><path d=\"M9 8V6a3 3 0 0 1 6 0v2\"/><line x1=\"9\" y1=\"13\" x2=\"15\" y2=\"13\"/><rect x=\"9\" y=\"17\" width=\"6\" height=\"3\" rx=\"1\"/>",
  "badge-check": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><polyline points=\"8 12 11 15 16 9\"/>",
  "banknote": "<rect x=\"2\" y=\"6\" width=\"20\" height=\"12\" rx=\"2\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/><line x1=\"6.2\" y1=\"10\" x2=\"6\" y2=\"10\"/><line x1=\"18\" y1=\"14\" x2=\"17.8\" y2=\"14\"/>",
  "bar-chart-2": "<line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"10\"/><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\"/><line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"14\"/>",
  "bell": "<path d=\"M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9\"/><path d=\"M10.3 21a2 2 0 0 0 3.4 0\"/>",
  "book": "<path d=\"M4 4.5A2.5 2.5 0 0 1 6.5 2H20v18H6.5A2.5 2.5 0 0 0 4 22.5Z\"/><path d=\"M4 4.5v16A2.5 2.5 0 0 0 6.5 23H20\"/>",
  "book-open": "<path d=\"M2 5c3-1.5 6-1.5 10 0v16c-4-1.5-7-1.5-10 0Z\"/><path d=\"M22 5c-3-1.5-6-1.5-10 0v16c4-1.5 7-1.5 10 0Z\"/>",
  "help-circle": "<circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3\"/><line x1=\"12\" y1=\"17\" x2=\"12.01\" y2=\"17\"/>",
  "image": "<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\"/><path d=\"m21 15-5-5L5 21\"/>",
  "building-2": "<rect x=\"4\" y=\"3\" width=\"9\" height=\"18\" rx=\"1\"/><rect x=\"15\" y=\"9\" width=\"6\" height=\"12\" rx=\"1\"/><line x1=\"7\" y1=\"7\" x2=\"7.01\" y2=\"7\"/><line x1=\"7\" y1=\"11\" x2=\"7.01\" y2=\"11\"/><line x1=\"7\" y1=\"15\" x2=\"7.01\" y2=\"15\"/><line x1=\"18\" y1=\"13\" x2=\"18.01\" y2=\"13\"/><line x1=\"18\" y1=\"17\" x2=\"18.01\" y2=\"17\"/>",
  "calculator": "<rect x=\"4\" y=\"2\" width=\"16\" height=\"20\" rx=\"2\"/><line x1=\"8\" y1=\"6\" x2=\"16\" y2=\"6\"/><line x1=\"8\" y1=\"11\" x2=\"8.01\" y2=\"11\"/><line x1=\"12\" y1=\"11\" x2=\"12.01\" y2=\"11\"/><line x1=\"16\" y1=\"11\" x2=\"16.01\" y2=\"11\"/><line x1=\"8\" y1=\"15\" x2=\"8.01\" y2=\"15\"/><line x1=\"12\" y1=\"15\" x2=\"12.01\" y2=\"15\"/><line x1=\"16\" y1=\"15\" x2=\"16\" y2=\"18\"/><line x1=\"8\" y1=\"18\" x2=\"8.01\" y2=\"18\"/><line x1=\"12\" y1=\"18\" x2=\"12.01\" y2=\"18\"/>",
  "calendar": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\"/><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\"/><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"/><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"/>",
  "calendar-days": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\"/><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\"/><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"/><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"/><line x1=\"8\" y1=\"14\" x2=\"8.01\" y2=\"14\"/><line x1=\"12\" y1=\"14\" x2=\"12.01\" y2=\"14\"/><line x1=\"16\" y1=\"14\" x2=\"16.01\" y2=\"14\"/>",
  "check": "<polyline points=\"4 12 9 17 20 6\"/>",
  "check-circle": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><polyline points=\"8 12 11 15 16 9\"/>",
  "chevron-left": "<polyline points=\"15 5 9 12 15 19\"/>",
  "chevron-up": "<polyline points=\"6 15 12 9 18 15\"/>",
  "chevron-down": "<polyline points=\"6 9 12 15 18 9\"/>",
  "chevrons-up-down": "<polyline points=\"7 9 12 4 17 9\"/><polyline points=\"7 15 12 20 17 15\"/>",
  "circle": "<circle cx=\"12\" cy=\"12\" r=\"8\"/>",
  "clipboard": "<rect x=\"5\" y=\"4\" width=\"14\" height=\"18\" rx=\"2\"/><rect x=\"9\" y=\"2\" width=\"6\" height=\"4\" rx=\"1\"/>",
  "clipboard-list": "<rect x=\"5\" y=\"4\" width=\"14\" height=\"18\" rx=\"2\"/><rect x=\"9\" y=\"2\" width=\"6\" height=\"4\" rx=\"1\"/><line x1=\"8\" y1=\"11\" x2=\"16\" y2=\"11\"/><line x1=\"8\" y1=\"15\" x2=\"16\" y2=\"15\"/>",
  "clock": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><polyline points=\"12 7 12 12 16 14\"/>",
  "coins": "<circle cx=\"9\" cy=\"9\" r=\"6\"/><path d=\"M14.5 8a6 6 0 1 1 0 10.9\"/>",
  "compass": "<circle cx=\"12\" cy=\"12\" r=\"9\"/><polygon points=\"15 9 13 13 9 15 11 11\"/>",
  "credit-card": "<rect x=\"2\" y=\"5\" width=\"20\" height=\"14\" rx=\"2\"/><line x1=\"2\" y1=\"10\" x2=\"22\" y2=\"10\"/>",
  "file-check": "<path d=\"M6 2h9l5 5v15H6Z\"/><polyline points=\"9 14 11 16 15 12\"/>",
  "file-spreadsheet": "<path d=\"M6 2h9l5 5v15H6Z\"/><line x1=\"8\" y1=\"13\" x2=\"16\" y2=\"13\"/><line x1=\"8\" y1=\"17\" x2=\"16\" y2=\"17\"/><line x1=\"12\" y1=\"13\" x2=\"12\" y2=\"20\"/>",
  "file-text": "<path d=\"M6 2h9l5 5v15H6Z\"/><line x1=\"9\" y1=\"13\" x2=\"15\" y2=\"13\"/><line x1=\"9\" y1=\"17\" x2=\"15\" y2=\"17\"/>",
  "folder": "<path d=\"M3 6a1 1 0 0 1 1-1h5l2 2h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z\"/>",
  "graduation-cap": "<path d=\"M2 9 12 4l10 5-10 5Z\"/><path d=\"M6 11.5V17c0 1.5 3 3 6 3s6-1.5 6-3v-5.5\"/><line x1=\"22\" y1=\"9\" x2=\"22\" y2=\"15\"/>",
  "history": "<path d=\"M3 12a9 9 0 1 0 3-6.7\"/><polyline points=\"3 3 3 8 8 8\"/><polyline points=\"12 7 12 12 16 14\"/>",
  "id-card": "<rect x=\"2\" y=\"5\" width=\"20\" height=\"14\" rx=\"2\"/><circle cx=\"8\" cy=\"12\" r=\"2\"/><line x1=\"13\" y1=\"10\" x2=\"18\" y2=\"10\"/><line x1=\"13\" y1=\"14\" x2=\"18\" y2=\"14\"/>",
  "inbox": "<polyline points=\"3 9 8 9 10 13 14 13 16 9 21 9\"/><path d=\"M3 9 5 4h14l2 5v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z\"/>",
  "key": "<circle cx=\"8\" cy=\"15\" r=\"4\"/><line x1=\"11\" y1=\"12\" x2=\"20\" y2=\"3\"/><line x1=\"16\" y1=\"7\" x2=\"19\" y2=\"10\"/>",
  "key-round": "<circle cx=\"8\" cy=\"8\" r=\"5\"/><line x1=\"12\" y1=\"12\" x2=\"21\" y2=\"21\"/><line x1=\"17\" y1=\"17\" x2=\"21\" y2=\"17\"/><line x1=\"17\" y1=\"21\" x2=\"17\" y2=\"17\"/>",
  "landmark": "<line x1=\"3\" y1=\"21\" x2=\"21\" y2=\"21\"/><line x1=\"5\" y1=\"21\" x2=\"5\" y2=\"10\"/><line x1=\"19\" y1=\"21\" x2=\"19\" y2=\"10\"/><polygon points=\"12 2 21 8 3 8\"/><line x1=\"9\" y1=\"21\" x2=\"9\" y2=\"10\"/><line x1=\"15\" y1=\"21\" x2=\"15\" y2=\"10\"/>",
  "layers": "<polygon points=\"12 3 21 8 12 13 3 8\"/><polyline points=\"3 14 12 19 21 14\"/>",
  "layout-dashboard": "<rect x=\"3\" y=\"3\" width=\"8\" height=\"9\" rx=\"1\"/><rect x=\"13\" y=\"3\" width=\"8\" height=\"5\" rx=\"1\"/><rect x=\"13\" y=\"10\" width=\"8\" height=\"11\" rx=\"1\"/><rect x=\"3\" y=\"14\" width=\"8\" height=\"7\" rx=\"1\"/>",
  "layout-grid": "<rect x=\"3\" y=\"3\" width=\"8\" height=\"8\" rx=\"1\"/><rect x=\"13\" y=\"3\" width=\"8\" height=\"8\" rx=\"1\"/><rect x=\"3\" y=\"13\" width=\"8\" height=\"8\" rx=\"1\"/><rect x=\"13\" y=\"13\" width=\"8\" height=\"8\" rx=\"1\"/>",
  "log-out": "<path d=\"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4\"/><polyline points=\"16 17 21 12 16 7\"/><line x1=\"21\" y1=\"12\" x2=\"9\" y2=\"12\"/>",
  "link": "<path d=\"M9 15 15 9\"/><path d=\"M11 5 13.5 2.5a4 4 0 0 1 5.5 5.8L16 11.3\"/><path d=\"M13 19 10.5 21.5a4 4 0 0 1-5.5-5.8L8 12.7\"/>",
  "lock": "<rect x=\"4\" y=\"10\" width=\"16\" height=\"11\" rx=\"2\"/><path d=\"M8 10V7a4 4 0 0 1 8 0v3\"/>",
  "megaphone": "<path d=\"M3 10v4a1 1 0 0 0 1 1h2l9 4V5l-9 4H4a1 1 0 0 0-1 1Z\"/><path d=\"M17 9a4 4 0 0 1 0 6\"/>",
  "chevron-right": "<polyline points=\"9 5 15 12 9 19\"/>",
  "menu": "<line x1=\"4\" y1=\"7\" x2=\"20\" y2=\"7\"/><line x1=\"4\" y1=\"12\" x2=\"20\" y2=\"12\"/><line x1=\"4\" y1=\"17\" x2=\"20\" y2=\"17\"/>",
  "moon": "<path d=\"M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5Z\"/>",
  "more-horizontal": "<circle cx=\"5\" cy=\"12\" r=\"1.4\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"12\" cy=\"12\" r=\"1.4\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"19\" cy=\"12\" r=\"1.4\" fill=\"currentColor\" stroke=\"none\"/>",
  "pencil": "<path d=\"M4 20l4-1 11-11-3-3L5 16Z\"/><line x1=\"14\" y1=\"7\" x2=\"17\" y2=\"10\"/>",
  "pencil-line": "<path d=\"M4 20l4-1 11-11-3-3L5 16Z\"/><line x1=\"14\" y1=\"7\" x2=\"17\" y2=\"10\"/><line x1=\"3\" y1=\"21\" x2=\"21\" y2=\"21\"/>",
  "plus": "<line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"/><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"/>",
  "printer": "<rect x=\"6\" y=\"9\" width=\"12\" height=\"7\" rx=\"1\"/><path d=\"M6 9V4h12v5\"/><path d=\"M8 16v4h8v-4\"/>",
  "receipt": "<path d=\"M5 2h14v20l-3-2-2 2-2-2-2 2-2-2-3 2Z\"/><line x1=\"8\" y1=\"7\" x2=\"16\" y2=\"7\"/><line x1=\"8\" y1=\"11\" x2=\"16\" y2=\"11\"/><line x1=\"8\" y1=\"15\" x2=\"13\" y2=\"15\"/>",
  "repeat": "<polyline points=\"17 1 21 5 17 9\"/><path d=\"M3 11V9a4 4 0 0 1 4-4h14\"/><polyline points=\"7 23 3 19 7 15\"/><path d=\"M21 13v2a4 4 0 0 1-4 4H3\"/>",
  "search": "<circle cx=\"11\" cy=\"11\" r=\"7\"/><line x1=\"21\" y1=\"21\" x2=\"16.5\" y2=\"16.5\"/>",
  "settings": "<circle cx=\"12\" cy=\"12\" r=\"3\"/><path d=\"M19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.3.9a7 7 0 0 0-2-1.2L14 3h-4l-.6 2.5a7 7 0 0 0-2 1.2l-2.3-.9-2 3.4 2 1.6A7 7 0 0 0 5 12a7 7 0 0 0 .1 1.2l-2 1.6 2 3.4 2.3-.9a7 7 0 0 0 2 1.2L10 21h4l.6-2.5a7 7 0 0 0 2-1.2l2.3.9 2-3.4-2-1.6A7 7 0 0 0 19 12Z\"/>",
  "skip-forward": "<polygon points=\"5 4 15 12 5 20\"/><line x1=\"19\" y1=\"5\" x2=\"19\" y2=\"19\"/>",
  "sun": "<circle cx=\"12\" cy=\"12\" r=\"4\"/><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"4\"/><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"22\"/><line x1=\"4\" y1=\"12\" x2=\"2\" y2=\"12\"/><line x1=\"22\" y1=\"12\" x2=\"20\" y2=\"12\"/><line x1=\"5\" y1=\"5\" x2=\"6.5\" y2=\"6.5\"/><line x1=\"17.5\" y1=\"17.5\" x2=\"19\" y2=\"19\"/><line x1=\"5\" y1=\"19\" x2=\"6.5\" y2=\"17.5\"/><line x1=\"17.5\" y1=\"6.5\" x2=\"19\" y2=\"5\"/>",
  "table": "<rect x=\"3\" y=\"4\" width=\"18\" height=\"16\" rx=\"1\"/><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"/><line x1=\"9\" y1=\"10\" x2=\"9\" y2=\"20\"/><line x1=\"15\" y1=\"10\" x2=\"15\" y2=\"20\"/>",
  "tag": "<path d=\"M20 12 12.5 19.5a1.5 1.5 0 0 1-2.1 0l-7.9-7.9a1.5 1.5 0 0 1 0-2.1L10 2h8a2 2 0 0 1 2 2Z\"/><circle cx=\"15\" cy=\"7\" r=\"1.3\" fill=\"currentColor\" stroke=\"none\"/>",
  "ticket": "<path d=\"M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4Z\"/><line x1=\"10\" y1=\"6\" x2=\"10\" y2=\"18\" stroke-dasharray=\"2 2\"/>",
  "trending-up": "<polyline points=\"3 17 9 11 13 15 21 6\"/><polyline points=\"15 6 21 6 21 12\"/>",
  "user": "<circle cx=\"12\" cy=\"8\" r=\"4\"/><path d=\"M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8\"/>",
  "user-check": "<circle cx=\"10\" cy=\"8\" r=\"4\"/><path d=\"M2 21c0-4.4 3.6-8 8-8s8 3.6 8 8\"/><polyline points=\"16 11 18 13 22 8\"/>",
  "user-plus": "<circle cx=\"9\" cy=\"8\" r=\"4\"/><path d=\"M1 21c0-4.4 3.6-8 8-8s8 3.6 8 8\"/><line x1=\"19\" y1=\"8\" x2=\"19\" y2=\"14\"/><line x1=\"16\" y1=\"11\" x2=\"22\" y2=\"11\"/>",
  "users": "<circle cx=\"9\" cy=\"8\" r=\"3.5\"/><path d=\"M2 21c0-3.6 3.1-6.5 7-6.5s7 2.9 7 6.5\"/><circle cx=\"17\" cy=\"8\" r=\"3\"/><path d=\"M16 14.7c2.9.6 5 2.9 5 6.3\"/>",
  "wallet": "<path d=\"M3 7a2 2 0 0 1 2-2h13a1 1 0 0 1 1 1v3\"/><path d=\"M3 7v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H6a2 2 0 0 1-2-2Z\"/><circle cx=\"16\" cy=\"14\" r=\"1.2\" fill=\"currentColor\" stroke=\"none\"/>",
  "x": "<line x1=\"5\" y1=\"5\" x2=\"19\" y2=\"19\"/><line x1=\"19\" y1=\"5\" x2=\"5\" y2=\"19\"/>"
}

export const MODULES: Record<string, MaquetteModule> = {
  "referentiel": {
    "label": "Référentiel",
    "icon": "landmark",
    "description": "Le socle du système : les écoles de l'établissement et le calendrier académique, années et périodes.",
    "entities": [
      "ecoles",
      "annees",
      "periodes"
    ],
    "reports": [],
    "groups": []
  },
  "offre": {
    "label": "Offre de formation",
    "icon": "graduation-cap",
    "description": "Les formations proposées, leurs niveaux et les classes ouvertes pour l'année académique en cours.",
    "entities": [
      "cycles",
      "offres",
      "niveaux",
      "classes"
    ],
    "reports": [],
    "groups": []
  },
  "personnes": {
    "label": "Personnes",
    "icon": "users",
    "description": "Le registre des personnes de l'école. Les étudiants sont l'accès principal ; les autres profils (enseignants, parents, personnel) sont regroupés à part, consultés moins souvent.",
    "entities": [
      "etudiants"
    ],
    "reports": [],
    "groups": [
      {
        "key": "autres",
        "label": "Autres profils",
        "icon": "users",
        "description": "Les profils moins consultés au quotidien : enseignants, parents, personnel administratif, et les liens parentaux qui rattachent chaque étudiant à ses parents/tuteurs.",
        "entities": [
          "enseignants",
          "parents",
          "personnelAdmin",
          "liensParentaux"
        ]
      }
    ]
  },
  "inscription": {
    "label": "Inscription",
    "icon": "clipboard-list",
    "description": "Le parcours d'un étudiant dans une offre de formation : la demande, le dossier documentaire requis, jusqu'à la carte étudiante.",
    "entities": [
      "inscriptions",
      "cartesEtudiantes"
    ],
    "reports": [],
    "groups": []
  },
  "finance": {
    "label": "Finance",
    "icon": "coins",
    "description": "La configuration et l'historique financiers : tarifs, réductions accordées, versements et reçus déjà enregistrés. Pour le traitement au jour le jour des dossiers en attente et le suivi des soldes, voir Caisse.",
    "entities": [
      "reductionsAppliquees",
      "versements",
      "recus"
    ],
    "reports": [],
    "groups": [
      {
        "key": "parametres",
        "label": "Paramètres",
        "icon": "settings",
        "description": "La configuration financière de base : les tarifications (frais et montants) par niveau et année, et les barèmes de réduction disponibles.",
        "entities": [
          "tarifications",
          "tranches",
          "reductions"
        ]
      }
    ]
  },
  "caisse": {
    "label": "Caisse",
    "icon": "wallet",
    "description": "Le poste de travail quotidien du comptable : traiter les inscriptions en attente de paiement (réduction, échéancier, versement), suivre les états de paiement par classe, les relances et les échéances à venir.",
    "entities": [],
    "reports": [
      "caissePending",
      "caisseEtats",
      "soldes",
      "relances",
      "echeancesDatees"
    ],
    "groups": []
  },
  "pedagogie": {
    "label": "Pédagogie",
    "icon": "book-open",
    "description": "Les matières enseignées par niveau et par période, les notes des étudiants, et les bulletins semestriels avec le bilan annuel.",
    "entities": [
      "unitesEnseignement",
      "matieres",
      "notes",
      "bulletins"
    ],
    "reports": [],
    "groups": []
  },
  "securite": {
    "label": "Sécurité",
    "icon": "lock",
    "description": "Les comptes utilisateurs de l'application et les rôles applicatifs qui encadrent leurs droits d'accès.",
    "entities": [
      "utilisateurs",
      "roles",
      "permissions",
      "utilisateurRoles"
    ],
    "reports": [],
    "groups": []
  }
}

export const ENTITIES: Record<string, MaquetteEntity> = {
  "ecoles": {
    "label": "École",
    "labelPlural": "Écoles",
    "icon": "building-2",
    "module": "referentiel",
    "storageKey": null
  },
  "annees": {
    "label": "Année académique",
    "labelPlural": "Années académiques",
    "icon": "calendar",
    "module": "referentiel",
    "storageKey": null
  },
  "cycles": {
    "label": "Cycle",
    "labelPlural": "Cycles",
    "icon": "repeat",
    "module": "offre",
    "storageKey": null
  },
  "offres": {
    "label": "Offre de formation",
    "labelPlural": "Offres de formation",
    "icon": "graduation-cap",
    "module": "offre",
    "storageKey": null
  },
  "niveaux": {
    "label": "Niveau",
    "labelPlural": "Niveaux",
    "icon": "layers",
    "module": "offre",
    "storageKey": null
  },
  "niveauOffre": {
    "label": "Niveau de formation",
    "labelPlural": "Niveaux par formation",
    "icon": "compass",
    "module": "offre",
    "storageKey": null
  },
  "classes": {
    "label": "Classe",
    "labelPlural": "Classes",
    "icon": "tag",
    "module": "offre",
    "storageKey": null
  },
  "personnes": {
    "label": "Personne",
    "labelPlural": "Personnes",
    "icon": "user",
    "module": "personnes",
    "storageKey": null
  },
  "liensParentaux": {
    "label": "Lien parental",
    "labelPlural": "Liens parentaux",
    "icon": "link",
    "module": "personnes",
    "storageKey": null
  },
  "inscriptions": {
    "label": "Inscription",
    "labelPlural": "Inscriptions",
    "icon": "clipboard-list",
    "module": "inscription",
    "storageKey": null
  },
  "historiqueStatutInscription": {
    "label": "Historique de statut",
    "labelPlural": "Historiques de statut",
    "icon": "history",
    "module": "inscription",
    "storageKey": null
  },
  "tranches": {
    "label": "Tranche",
    "labelPlural": "Calendrier des tranches",
    "icon": "calendar-days",
    "module": "finance",
    "storageKey": null
  },
  "tarifications": {
    "label": "Tarification",
    "labelPlural": "Tarifications",
    "icon": "tag",
    "module": "finance",
    "storageKey": null
  },
  "reductions": {
    "label": "Réduction",
    "labelPlural": "Réductions",
    "icon": "ticket",
    "module": "finance",
    "storageKey": null
  },
  "reductionsAppliquees": {
    "label": "Réduction appliquée",
    "labelPlural": "Réductions appliquées",
    "icon": "banknote",
    "module": "finance",
    "storageKey": null
  },
  "echeanciers": {
    "label": "Échéancier",
    "labelPlural": "Échéanciers",
    "icon": "calendar-days",
    "module": "finance",
    "storageKey": null
  },
  "lignesEcheance": {
    "label": "Ligne d'échéance",
    "labelPlural": "Lignes d'échéance",
    "icon": "file-text",
    "module": "finance",
    "storageKey": null
  },
  "versements": {
    "label": "Versement",
    "labelPlural": "Versements",
    "icon": "credit-card",
    "module": "finance",
    "storageKey": null
  },
  "utilisateurs": {
    "label": "Utilisateur",
    "labelPlural": "Utilisateurs",
    "icon": "lock",
    "module": "securite",
    "storageKey": null
  },
  "roles": {
    "label": "Rôle",
    "labelPlural": "Rôles",
    "icon": "key",
    "module": "securite",
    "storageKey": null
  },
  "permissions": {
    "label": "Permission",
    "labelPlural": "Permissions",
    "icon": "key-round",
    "module": "securite",
    "storageKey": null
  },
  "utilisateurRoles": {
    "label": "Attribution de rôle",
    "labelPlural": "Attributions de rôle",
    "icon": "badge-check",
    "module": "securite",
    "storageKey": null
  },
  "unitesEnseignement": {
    "label": "Unité d'enseignement",
    "labelPlural": "Unités d'enseignement",
    "icon": "layers",
    "module": "pedagogie",
    "storageKey": null
  },
  "matieres": {
    "label": "Matière (ECUE)",
    "labelPlural": "Matières (ECUE)",
    "icon": "book",
    "module": "pedagogie",
    "storageKey": null
  },
  "notes": {
    "label": "Note",
    "labelPlural": "Notes",
    "icon": "pencil-line",
    "module": "pedagogie",
    "storageKey": null
  },
  "bulletins": {
    "label": "Bulletin",
    "labelPlural": "Bulletins",
    "icon": "file-check",
    "module": "pedagogie",
    "storageKey": null
  },
  "periodes": {
    "label": "Période",
    "labelPlural": "Périodes",
    "icon": "calendar-days",
    "module": "referentiel",
    "storageKey": null
  },
  "typesDocument": {
    "label": "Type de document",
    "labelPlural": "Types de document",
    "icon": "clipboard",
    "module": "inscription",
    "storageKey": null
  },
  "documentsDossier": {
    "label": "Document du dossier",
    "labelPlural": "Documents du dossier",
    "icon": "folder",
    "module": "inscription",
    "storageKey": null
  },
  "cartesEtudiantes": {
    "label": "Carte étudiante",
    "labelPlural": "Cartes étudiantes",
    "icon": "id-card",
    "module": "inscription",
    "storageKey": null
  },
  "recus": {
    "label": "Reçu",
    "labelPlural": "Reçus",
    "icon": "receipt",
    "module": "finance",
    "storageKey": null
  },
  "imputations": {
    "label": "Imputation",
    "labelPlural": "Imputations",
    "icon": "calculator",
    "module": "finance",
    "storageKey": null
  },
  "etudiants": {
    "label": "Étudiant",
    "labelPlural": "Étudiants",
    "icon": "backpack",
    "module": "personnes",
    "storageKey": "personnes"
  },
  "enseignants": {
    "label": "Enseignant",
    "labelPlural": "Enseignants",
    "icon": "user-check",
    "module": "personnes",
    "storageKey": "personnes"
  },
  "parents": {
    "label": "Parent",
    "labelPlural": "Parents",
    "icon": "users",
    "module": "personnes",
    "storageKey": "personnes"
  },
  "personnelAdmin": {
    "label": "Personnel administratif",
    "labelPlural": "Personnel administratif",
    "icon": "archive",
    "module": "personnes",
    "storageKey": "personnes"
  }
}

export const REPORTS: Record<string, MaquetteReport> = {
  "soldes": {
    "label": "Suivi des soldes",
    "icon": "bar-chart-2",
    "module": "caisse"
  },
  "relances": {
    "label": "État des relances",
    "icon": "megaphone",
    "module": "caisse"
  },
  "echeancesDatees": {
    "label": "État des échéances",
    "icon": "calendar-days",
    "module": "caisse"
  },
  "caissePending": {
    "label": "Inscriptions en attente",
    "icon": "inbox",
    "module": "caisse"
  },
  "caisseEtats": {
    "label": "États par classe",
    "icon": "table",
    "module": "caisse"
  }
}

export const ROOT_PARAMETRES_MODULES = ['referentiel']
export const ROOT_PARAMETRES_ENTITIES = ['typesDocument']

/** Collections de la base de données de la maquette (une par adresse /api/<collection>). */
export const COLLECTIONS = ["ecoles", "annees", "periodes", "offres", "cycles", "niveaux", "niveauOffre", "classes", "personnes", "inscriptions", "historiqueStatutInscription", "tarifications", "echeanciers", "lignesEcheance", "cartesEtudiantes", "versements", "recus", "imputations", "utilisateurs", "roles", "permissions", "utilisateurRoles", "liensParentaux", "typesDocument", "documentsDossier", "reductions", "reductionsAppliquees", "matieres", "unitesEnseignement", "notes", "bulletins", "tranches", "fraisSupplementaires"]

/** Listes de valeurs (ENUMS de la maquette). */
export const ENUMS: Record<string, string[]> = {
  "statutAnnee": [
    "PREPARATION",
    "OUVERTE",
    "CLOTUREE"
  ],
  "typePeriode": [
    "TRIMESTRE",
    "SEMESTRE",
    "QUADRIMESTRE"
  ],
  "sexe": [
    "MASCULIN",
    "FEMININ"
  ],
  "rolePersonne": [
    "ETUDIANT",
    "ENSEIGNANT",
    "PARENT",
    "PERSONNEL_ADMIN"
  ],
  "typeContrat": [
    "PERMANENT",
    "VACATAIRE",
    "STAGIAIRE"
  ],
  "typeLienParental": [
    "PERE",
    "MERE",
    "TUTEUR",
    "AUTRE"
  ],
  "typeInscription": [
    "NOUVELLE",
    "REINSCRIPTION",
    "TRANSFERT"
  ],
  "statutInscription": [
    "BROUILLON",
    "EN_ATTENTE_VALIDATION",
    "EN_ATTENTE_PAIEMENT",
    "VALIDEE",
    "ANNULEE",
    "ABANDON",
    "TRANSFEREE",
    "TERMINEE"
  ],
  "statutDocument": [
    "ATTENDU",
    "DEPOSE",
    "VALIDE",
    "REJETE"
  ],
  "statutCarte": [
    "ACTIVE",
    "PERDUE",
    "EXPIREE",
    "DESACTIVEE"
  ],
  "statutEcheancier": [
    "A_JOUR",
    "EN_RETARD",
    "SOLDE"
  ],
  "statutLigne": [
    "ATTENDU",
    "PARTIEL",
    "PAYE",
    "EN_RETARD"
  ],
  "typeReduction": [
    "POURCENTAGE",
    "MONTANT_FIXE"
  ],
  "typeEvaluation": [
    "DEVOIR",
    "COMPOSITION",
    "INTERROGATION",
    "TP"
  ],
  "motifReduction": [
    "BOURSE",
    "FRATRIE",
    "MERITE",
    "PERSONNEL",
    "SOCIAL"
  ],
  "modePaiement": [
    "ESPECES",
    "MOBILE_MONEY",
    "VIREMENT",
    "CHEQUE",
    "CARTE"
  ],
  "statutVersement": [
    "ENREGISTRE",
    "ANNULE"
  ],
  "roleUtilisateur": [
    "ADMIN",
    "SECRETAIRE",
    "CAISSIER",
    "ENSEIGNANT"
  ]
}
